export default {
  int: {
    authorizationUrl: 'https://int.subscriptions.cimpress.io',
    subscriptionsUrl: 'https://int-subscriptions.commerce.cimpress.io',
  },
  prd: {
    authorizationUrl: 'https://subscriptions.cimpress.io',
    subscriptionsUrl: 'https://subscriptions.commerce.cimpress.io',
  },
};
